import React, { useState } from "react";
import { Icon } from "@iconify/react";
import "./ShareModal.css";
import { getCurrentUserId } from "../../utils/auth";

const ShareModal = ({
  post,
  isPrime,
  feedType,
  isRevolution, 
  onClose,
  onInternalShare,
  onExternalShare,
  onRepost,
}) => {
  const [showRepostBox, setShowRepostBox] = useState(false);
  const [description, setDescription] = useState("");
  const currentUserId = getCurrentUserId();

  if (!post) return null;

  // ✅ Fallback: check both the prop AND post.feedType so it works
  //    even if the parent forgets to pass feedType explicitly

  const isPublicPost = !isPrime && !isRevolution;  // ✅ clean and explicit
  const isOwner = String(currentUserId) === String(post?.user?._id);

  const handleSubmitRepost = () => {
    onRepost(post, description || "");
    setDescription("");
    setShowRepostBox(false);
  };

  return (
    <div className="share-modal-backdrop">
      <div className="share-modal">
        <h5 className="mb-3">Share Post</h5>

        {!showRepostBox ? (
          <>
            {/* ✅ External Share — always visible for all feed types */}
            <button
              className="share-option"
              onClick={() => onExternalShare(post)}
            >
              <Icon icon="mdi:share-variant" />
              <span>External share</span>
            </button>

            {/* ✅ Repost — only for PUBLIC feed, and only if NOT the owner */}
            {isPublicPost && !isOwner && (
              <button
                className="share-option"
                onClick={() => setShowRepostBox(true)}
              >
                <Icon icon="mdi:repeat" />
                <span>Repost</span>
              </button>
            )}
          </>
        ) : (
          <>
            {/* ✅ Repost Input Box */}
            <textarea
              className="repost-textarea"
              placeholder="Add your thoughts..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            <div className="d-flex justify-content-end gap-2">
              <button
                className="share-back rounded-pill w-50"
                onClick={() => setShowRepostBox(false)}
              >
                Back
              </button>

              <button
                className="share-submit rounded-pill w-50"
                onClick={handleSubmitRepost}
                // disabled={!description.trim()}
              >
                Repost
              </button>
            </div>
          </>
        )}

        <button className="share-cancel rounded-pill mt-3" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ShareModal;